var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62532 0.458488C9.72447 0.384093 9.84337 0.340882 9.96711 0.333975C10.1142 0.325764 10.2594 0.370073 10.3772 0.458488L19.747 7.48983C20.4029 7.98205 19.651 8.98294 18.9951 8.49082L9.99884 1.74146L1.0246 8.47373C0.329365 8.99535 -0.417605 7.99441 0.277555 7.47274L9.62532 0.458488Z",
    fill: "#F4B644"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99884 3.81913C9.84287 3.82012 9.7244 3.86907 9.62532 3.94364L1.81924 9.81896C1.66271 9.93678 1.57023 10.1211 1.57023 10.317V19.7092C1.57023 20.055 1.85205 20.333 2.19764 20.333H7.51725C7.86428 20.333 8.14594 20.0528 8.14467 19.7056L8.12636 14.7153H11.8762V19.7092C11.8762 20.0531 12.1551 20.333 12.4987 20.333H17.8037C18.1493 20.333 18.4311 20.055 18.4311 19.7092V10.317C18.4311 10.1212 18.3386 9.93675 18.1821 9.81896L10.3772 3.94364C10.2765 3.86779 10.1548 3.81814 9.99884 3.81913Z",
    fill: "#161E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/m.90f63084d98ac03a7715c16519cbe45c.svg";
export { ForwardRef as ReactComponent };